import React from 'react';

function LegalSectionRenderer({ sections, classNamePrefix, sectionHeadingTag: SectionHeadingTag = 'h2' }) {
  return sections.map((section, sectionIndex) => (
    <div key={`${section.heading || 'intro'}-${sectionIndex}`} className={`${classNamePrefix}__section`}>
      {section.heading && (
        <SectionHeadingTag className={`${classNamePrefix}__section-heading`}>
          {section.heading}
        </SectionHeadingTag>
      )}
      {section.blocks.map((block, blockIndex) => {
        if (block.type === 'subheading') {
          return (
            <h3 key={`${sectionIndex}-subheading-${blockIndex}`} className={`${classNamePrefix}__subheading`}>
              {block.text}
            </h3>
          );
        }

        if (block.type === 'list') {
          return (
            <ul key={`${sectionIndex}-list-${blockIndex}`} className={`${classNamePrefix}__list`}>
              {block.items.map((item, itemIndex) => (
                <li key={`${sectionIndex}-list-${blockIndex}-${itemIndex}`} className={`${classNamePrefix}__list-item`}>
                  {item}
                </li>
              ))}
            </ul>
          );
        }

        return (
          <p key={`${sectionIndex}-paragraph-${blockIndex}`} className={`${classNamePrefix}__paragraph`}>
            {block.text}
          </p>
        );
      })}
    </div>
  ));
}

export default LegalSectionRenderer;
